import type { DateRange } from '@mui/x-date-pickers-pro';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { EnhancedDateRangePicker } from 'components/enhanced/form/adapters/date-time/EnhancedDateRangePicker';
import { Dayjs } from 'dayjs';
import { costReportService } from 'features/cost-analysis/cost-report/api/cost-report.service';
import TenantPage from 'layouts/TenantPage';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { costAnalysisService } from 'shared/services';
import toast from 'shared/utils/toast';
import { CostReport } from '../cost-report';

export const CostReportList = () => {
  const translationPrefix = 'pages.cost_report.list';
  const { t } = useTranslation();

  const [range, setRange] = useState<DateRange<Dayjs>>([null, null]);

  const handleAcceptRange = (acceptedRange: DateRange<Dayjs>) => {
    const startDate = acceptedRange[0];
    const endDate = acceptedRange[1];

    // Verifica di sicurezza: esegue l'operazione solo se entrambe le date sono valide
    if (!startDate || !endDate || !startDate.isValid() || !endDate.isValid()) {
      return;
    }
    costAnalysisService
      .runCostAnalysis(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'))
      .then((res) => {
        console.log(res.details);
        // Show success toast
        toast.success(t(`${translationPrefix}.report_success`));
      })
      .catch(() => {
        toast.error(t('global.error_occurred', "Errore durante l'elaborazione."));
      });
  };

  const columns = CostReport();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <EnhancedDateRangePicker
          value={range}
          onChange={(newRange) => {
            setRange(newRange);
          }}
          onAccept={handleAcceptRange}
        />
      }>
      <EnhancedDataGrid columns={columns} service={costReportService} />
    </TenantPage>
  );
};

export default CostReportList;
